export const EVO_WRAPPER_MESSAGE_TYPE = 'EVO_WRAPPER_MESSAGE';

export const EVO_WRAPPER_INIT_SUBTYPE = 'EVO_WRAPPER_INIT';
export const EVO_WRAPPER_TOGGLE_FULLSCREEN_SUBTYPE = 'EVO_WRAPPER_TOGGLE_FULLSCREEN';
